// @ts-nocheck
import { paginationStyles } from "@insite/content-library/Widgets/MyLists/MyListsPagination";
import { css } from "styled-components";

Object.assign(paginationStyles, {
    wrapper: {
        css: css`
            padding: 0;
            margin-top: 3em;
        `,
    },
});
